import { Injectable } from '@angular/core';
import { ProxyService } from '../proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class UserPermissionService {
    public static $name: string = 'userPermissionService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getHasAccess(feature: string): angular.IPromise<boolean> {
        return this.proxyService.request({
            endPoint: 'userPermission',
            queryParams: {
                feature: feature
            },
            route: 'getHasAccess'
        }).as<boolean>();
    }
}